module.exports = __webpack_public_path__ + "static/media/F13.4f91e6e1.png";